module.exports = __webpack_public_path__ + "static/media/sallie-sleeping-doghouse-remove-loop.1ec6f7d5.gif";